<template>
  <a-col
    :span="is_show_field ? (field_item.span !== undefined ? field_item.span : 24) : 0"
    :offset="field_item.offset"
    :push="field_item.push"
    :pull="field_item.pull"
  >
    <field-render-2
      v-model:value="model[field_item.name]"
      v-model:label="model[field_item.name + '.label']"
      v-model:is_show_field="is_show_field"
      :field="field_item"
      :formModel="model"
      :outModel="outModel"
      :key="field_item.name"
      :validateInfos="validateInfos"
      :options="options[field_item.datasource ? field_item.datasource : field_item.name]"
      :alwaysShowGroup="alwaysShowGroup"
      :context="context"
      :inner-model="innerModel"
      :global-inner-model="globalInnerModel"
      :nestValidate="nestValidate"
      :base-key-path="baseKeyPath"
      :worker-host-functions="workerHostFunctions"
      @update_model="onUpdateModel"
      @update_name2="onUpdateName2"
    />
  </a-col>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import FieldRender2 from 'liyu-pc-base/components/FormRender/FieldRender2.vue';

export default defineComponent({
  name: 'FieldCol',
  components: {
    FieldRender2,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    outModel: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Object,
      required: true,
      default: () => {},
    },
    validateInfos: {
      type: Object,
      default: () => {},
    },
    alwaysShowGroup: {
      type: Boolean,
      default: false,
    },
    field_item: {
      type: Object,
      default: () => {},
    },
    context: {
      type: Object,
      default: null,
    },
    innerModel: {
      default: null,
    },
    globalInnerModel: {
      default: null,
    },
    nestValidate: {
      type: Object as PropType<Record<string, any> | null>,
      default: null,
    },
    baseKeyPath: {
      type: Array,
      default: () => [],
    },
    workerHostFunctions: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['update_model', 'update_name2'],
  setup(props, { emit }) {
    const is_show_field = ref(true);
    const onUpdateModel = params => {
      emit('update_model', params);
    };
    const onUpdateName2 = params => {
      emit('update_name2', params);
    };
    return { is_show_field, onUpdateModel, onUpdateName2 };
  },
});
</script>
<style lang="less" scoped>
.cards {
  ::v-deep(.ant-card-head) {
    padding: 0 8px;
    min-height: 44px;
    background-color: rgba(0, 0, 0, 0.02);
  }
}
</style>
